import React from "react";
import { STATUS_TONES, StatusTone } from "utils/constant.utils";
import "./status_badge.ui.scss";

interface IStatusBadge {
  status: string;
  label?: string;
  // Overrides the tone looked up from `status` in STATUS_TONES.
  tone?: StatusTone;
}

const StatusBadge = (props: IStatusBadge) => {
  const { status, label, tone } = props;
  const resolvedTone: StatusTone = tone || STATUS_TONES[status] || "neutral";

  return (
    <span data-testid="status_badge" className={`status_badge status_badge--${resolvedTone}`}>
      {label || status}
    </span>
  );
};

export default StatusBadge;
